module.exports = __webpack_public_path__ + "static/media/LampParticles.641951d0.svg";